import { useState } from 'react';
import { Button } from '@material-ui/core';
import { DynamicAVDevice, getDynamicAVDevices } from 'circulator/components/CreateProcedureButton/getDynamicAVDevices';
import { DynamicCameraPublisher } from 'circulator/components/Procedure/DynamicCameraPublisher';
import { StreamType } from 'common/types';

export const CameraTestStart = () => {
    const [devices, setDevices] = useState<DynamicAVDevice[]>([]);
    const [showCaptures, setShowCaptures] = useState<boolean>(false);

    async function getDevices() {
        console.log('Getting dynamic AV devices...');
        const dynamicAVDevices = await getDynamicAVDevices();
        setDevices(dynamicAVDevices);
    }

    return (
        <>
            <h1>Camera Test Start</h1>
            <Button onClick={getDevices} variant="contained">
                Get Devices
            </Button>
            <Button onClick={() => setShowCaptures(true)} variant="contained">
                Start Capture
            </Button>
            <h3>Devices</h3>
            <ul>
                {devices.map((device, index) => (
                    <li key={index}>
                        {device.label}
                        <ul>
                            <li>Group ID: {device.groupId}</li>
                            <li>Audio ID: {device.audioId}</li>
                            <li>Video ID: {device.videoId}</li>
                        </ul>
                    </li>
                ))}
            </ul>
            <h3>Captures</h3>
            <ul>
                {showCaptures &&
                    devices
                        .filter(device => !!device.videoId)
                        .map((device, index) => (
                            <li key={index}>
                                {device.label}
                                <DynamicCameraPublisher
                                    // @ts-ignore
                                    procedure={{
                                        publishUrl: '',
                                        publishIceServers: [],
                                    }}
                                    // @ts-ignore
                                    stream={{
                                        channelId: `Dynamic-Device-${device.audioId ? device.audioId : ''}--${device.videoId}-0`,
                                        type: device.audioId ? StreamType.AUDIO_VIDEO : StreamType.VIDEO_ONLY,
                                        publishToken: '',
                                    }}
                                />
                            </li>
                        ))}
            </ul>
        </>
    );
};
